import peopleaiService from "../services/peopleai";
import { setFailedMessage } from "./message";
import {
    SET_AI_CHIPS,
    SET_AI_FILTER,
    SET_CAMPAIGN_EDIT_LOADER,
    SET_CAMPAIGN_ID,
    SET_CAMPAIGN_OBJECTIVE,
    SET_CAMPAIGN_OBJECTIVE_LOADER,
    SET_CAMPAIGN_UPDATE_LIST,
    SET_CAMPAIGN_UPDATE_LIST_LOADER,
    SET_FILTER_STEPS,
    SET_GOALS_LIST,
    SET_GOALS_LIST_LOADER,
    SET_OBJECTIVE_FILTER,
    SET_PEOPLE_CARDS,
    SET_PEOPLE_CARDS_CAMPAIGN_DETAIL,
    SET_PEOPLE_FILTER_DATA,
    SET_PEOPLE_LEADS_LOADER,
    SET_PROFILE_COUNT,
    SET_PROFILE_DATA,
    SET_PROFILE_IDS,
    SET_PUBLIC_COMPANY,
    SET_PUBLIC_COMPANY_LOADER,
    SET_PUBLIC_PROFILE,
    SET_SINGLE_CAMPAIGN_DETAIL,
    SET_SINGLE_CAMPAIGN_DETAIL_LOADER,
} from "./types";

export const setFilterStepsAction = (payload) => (dispatch) => {
    dispatch({ type: SET_FILTER_STEPS, payload });
};

export const setObjectiveFilter = (payload) => (dispatch) => {
    dispatch({ type: SET_OBJECTIVE_FILTER, payload });
};

export const getAiAction = (payload) => async (dispatch) => {
    return peopleaiService.getAiAPI(payload).then((resp) => {
        if (resp?.status) {
            dispatch({ type: SET_AI_CHIPS, payload: resp?.data?.chips || [] });
        } else {
            dispatch({ type: SET_AI_CHIPS, payload: [] });
        }
        return resp;
    });
};

export const getAIObjectivesAction = (payload) => async (dispatch) => {
    dispatch({ type: SET_CAMPAIGN_OBJECTIVE_LOADER, payload: true });
    return peopleaiService.getAiAPI(payload).then((resp) => {
        if (resp?.status) {
            dispatch({ type: SET_CAMPAIGN_OBJECTIVE, payload: resp?.data });
        } else {
            dispatch({ type: SET_CAMPAIGN_OBJECTIVE, payload: {} });
        }
        return resp;
    });
};

export const updateObjectiveTitle = ({ title, description }) => (dispatch, getState) => {
    const currentObjective = getState()?.peopleai?.campaignObjective || {};
    dispatch({ type: SET_CAMPAIGN_OBJECTIVE, payload: { ...currentObjective, title, description } });
};

export const getAiFilterAction = (payload) => async (dispatch) => {
    return peopleaiService.getAiAPI(payload).then((resp) => {
        if (resp?.status) {
            dispatch({ type: SET_AI_FILTER, payload: resp?.data });
        } else {
            dispatch({ type: SET_AI_FILTER, payload: {} });
        }
        return resp;
    });
};

export const getLeadsProfileAction = (payload, navigate, payloadData, navigateBack, isEdit = false, isComponent = false) => async (dispatch) => {
    dispatch({ type: SET_PEOPLE_LEADS_LOADER, payload: true });
    dispatch({ type: SET_PEOPLE_FILTER_DATA, payload: payloadData });
    if (!isEdit && typeof navigate === "function") {
        navigate("genreatedLeads");
    }
    dispatch(setFilterStepsAction(1));
    return peopleaiService.getleadsProfile(payload).then((resp) => {
        if (resp?.status) {
            dispatch({ type: SET_PROFILE_COUNT, payload: resp?.data?.total });
            dispatch({ type: SET_PROFILE_IDS, payload: resp?.data?.ids });
            dispatch({ type: SET_PEOPLE_CARDS, payload: resp?.data?.profiles || [] });
            dispatch({ type: SET_PEOPLE_CARDS_CAMPAIGN_DETAIL, payload: resp?.data?.campaign || {} });
        } else {
            if (typeof navigateBack === "function") navigateBack();
            dispatch({ type: SET_PEOPLE_CARDS, payload: [] });
            dispatch({ type: SET_PEOPLE_CARDS_CAMPAIGN_DETAIL, payload: {} });
            dispatch(setFailedMessage(resp?.message || "Something went wrong"));
        }
        return resp;
    });
};

export const addCampaignAiAction = (payload) => async (dispatch) => {
    dispatch({ type: SET_CAMPAIGN_ID, payload: null });
    dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL, payload });
    return { status: true, data: payload };
};

export const addCampaignAction = (payload) => async (dispatch) => {
    dispatch({ type: SET_CAMPAIGN_EDIT_LOADER, payload: true });
    return peopleaiService.addCampaign(payload).then((resp) => {
        dispatch({ type: SET_CAMPAIGN_EDIT_LOADER, payload: false });
        if (resp?.status) {
            dispatch({ type: SET_CAMPAIGN_ID, payload: resp?.data });
        } else {
            dispatch(setFailedMessage(resp?.data || "Something went wrong"));
        }
        return resp;
    });
};

const normalizeGoalItem = item => ({
    ...item,
    id: item?.id || item?._id || item?.name || item?.title,
    name: item?.name || item?.title || "",
    description: item?.description || "",
});

const mergeGoalLists = (baseGoals = [], generatedGoals = []) => {
    const map = new Map();
    [...baseGoals, ...generatedGoals].forEach(item => {
        const normalized = normalizeGoalItem(item);
        const key = String(normalized.id || normalized.name).toLowerCase();
        if (key && !map.has(key)) map.set(key, normalized);
    });
    return Array.from(map.values());
};

export const getMergedGoalsAction = (role, company, query) => async (dispatch) => {
    dispatch({ type: SET_GOALS_LIST_LOADER, payload: true });
    const companyId = company?.id || company?._id;

    const [savedResp, generatedResp] = await Promise.all([
        companyId ? peopleaiService.getGoals(role, companyId).catch(() => null) : Promise.resolve(null),
        peopleaiService.getAiAPI(query).catch(() => null),
    ]);

    const savedGoals = Array.isArray(savedResp?.data) ? savedResp.data : [];
    const generatedGoals = Array.isArray(generatedResp?.data?.goals)
        ? generatedResp.data.goals
        : Array.isArray(generatedResp?.data)
            ? generatedResp.data
            : [];
    const goals = mergeGoalLists(savedGoals, generatedGoals);

    dispatch({ type: SET_GOALS_LIST, payload: goals });
    return {
        ...(generatedResp || {}),
        status: Boolean(goals.length),
        data: goals,
    };
};

export const getSingleCampaignDetailAction = (campaignId) => async (dispatch) => {
    dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL_LOADER, payload: true })
    return await peopleaiService.getSingleCampaignDetail(campaignId).then(async (resp) => {
        if (resp.status) {
            dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL, payload: resp?.data });
        } else {
            dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL, payload: {} });
        }
        return resp;
    });
};



export const getProfileVisitAction = (campaignId) => async (dispatch) => {
    return await peopleaiService.getProfileVisit(campaignId).then(async (resp) => {
        return resp;
    });
};


export const getPublicCompanyAction = (campaignId) => async (dispatch) => {
    dispatch({ type: SET_PUBLIC_COMPANY_LOADER, payload: true })
    return await peopleaiService.getPublicCompany(campaignId).then(async (resp) => {
        if (resp.status) {
            dispatch({ type: SET_PUBLIC_COMPANY, payload: resp?.data });
        } else {
            dispatch({ type: SET_PUBLIC_COMPANY, payload: {} });
        }
        return resp;
    });
};
export const getProfileByTrackingIdAction = (trackingId) => async (dispatch) => {
    return await peopleaiService.getProfileByTrackingId(trackingId).then(async (resp) => {
        if (resp.status) {
            dispatch({ type: SET_PUBLIC_PROFILE, payload: resp?.data });
        } else {
            dispatch({ type: SET_PUBLIC_PROFILE, payload: {} });
        }
        return resp;
    });
};

export const getCampaignUpdateAction = (page, limit, campaignId) => async (dispatch) => {
    dispatch({ type: SET_CAMPAIGN_UPDATE_LIST_LOADER, payload: true })
    return await peopleaiService.getCampaignUpdate(page, limit, campaignId).then(async (resp) => {
        if (resp.status) {
            dispatch({ type: SET_CAMPAIGN_UPDATE_LIST, payload: resp?.data, count: resp?.count, total: resp?.total, page: page });
        } else {
            dispatch({ type: SET_CAMPAIGN_UPDATE_LIST, payload: '' });
        }
        return resp;
    });
};

export const getProfileByIdsAction = (payload) => async (dispatch) => {
    return await peopleaiService.getProfileById(payload).then(async (resp) => {
        if (resp.status) {
            dispatch({ type: SET_PROFILE_DATA, payload: resp?.data })
            return resp;
        }
    });
};
